import axios from "axios";
import { setAlert } from "../alert";
import {
    GET_AUTOMOBILE,
    REMOVE_AUTOMOBILE,
    SET_AUTOMOBILE_DATA,
    SET_AUTOMOBILE_LOADING,
    REMOVE_AUTOMOBILE_LOADING,
    SET_AUTOMOBILE_DROPDOWN,
    SET_AUTOMOBILE_OLD_VALUE,
    REMOVE_AUTOMOBILE_OLD_VALUE,
    SET_AUTOMOBILE_CONTACTS
} from "../../types";
import { getMiscContract, removeMiscContract } from "../misc/contracts";
import { updateStatus, fieldToggle } from "./status";

import { handleError } from "../error";
import { handleResponse } from "../response";
import { triggerConfirmModal } from "../modals/confirm";
import { updateContacts, setStaticContacts } from "./contacts";

import { toNumberFloat } from "@helpers";

/**
 * @name    getAutomobileAssets
 * @returns {function(...[*]=)}
 */

export const getAutomobileAssets = () => async (dispatch, getState) => {
    try {
        const {
            automobiles: {
                automobileData: { group_code }
            }
        } = getState();
        // DESC: Outside methods
        await dispatch(getMiscContract(group_code));
    } catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

/**
 * @name    removeAutomobileAssets
 */
export const removeAutomobileAssets = () => async dispatch => {
    try {
        await dispatch(removeMiscContract());
    } catch (error) {
        dispatch(setAlert(error.message, "error"));
    }
};

/**
 * @name	processDataOnLoad
 */
export const processDataOnLoad = tab => async (dispatch, getState) => {
    //	This method will process data on pre-load to calculate
    //	neccesarity fields and options and set it to global state
    //	this is a required method. Application will throw error with out this.
    try {
        const {
            automobiles: { automobileData }
        } = getState();
        const newAutomobileData = { ...automobileData };
        switch (tab) {
            case "status": {
                await dispatch(
                    fieldToggle({
                        name: "under_warranty",
                        value: newAutomobileData.under_warranty
                    })
                );
                break;
            }
            case "contacts": {
                break;
            }
            default:
                await dispatch(setStaticContacts());
                break;
        }
    } catch (error) {
        dispatch(handleError(error));
    }
};

/**
 * @name    getAutomobile
 * @param id
 * @returns {function(...[*]=)}
 */
export const getAutomobile = ({
    component,
    verb,
    componentID
}) => async dispatch => {
    try {
        dispatch({ type: SET_AUTOMOBILE_LOADING });
        const result = await axios.post(
            `/${component}/${verb}/${componentID}?ReactAPI=true`
        );
        dispatch(handleResponse(result));
        await dispatch({
            type: GET_AUTOMOBILE,
            payload: result.data.automobile
        });
        await dispatch({
            type: SET_AUTOMOBILE_DROPDOWN,
            payload: result.data.dropdowns
        });
        await dispatch({
            type: SET_AUTOMOBILE_CONTACTS,
            payload: result.data.contacts
        });
        await dispatch(getAutomobileAssets());
        dispatch({ type: REMOVE_AUTOMOBILE_LOADING });

        return {
            code: result.data.automobile.code || result.data.property.code_temp,
            make: result.data.automobile.make,
            model: result.data.automobile.model,
            year: result.data.automobile.year
        };
    } catch (error) {
        dispatch(handleError(error));
    }
};

/**
 * @name	removeAutomobile
 */
export const removeAutomobile = () => async dispatch => {
    try {
        dispatch({ type: REMOVE_AUTOMOBILE });
    } catch (error) {
        dispatch(handleError(error));
    }
};

/**
 * @name setAutomobileFields
 * @param data
 * @returns {function(...[*]=)}
 */

// export const setAutomobileFields = () => async dispatch => {
//     try {
//         dispatch({ type :SET_AUTOMOBILE_FIELDS });
//     }
//     catch (error) {
//         dispatch(setAlert(error.message, "error"));
//     }
// };

/**
 * @name    updateAutomobileData
 * @param   event
 * @param   currentTab
 * @returns {function(...[*]=)}
 * @description
 * This Function Update global property's fields
 * This Function Update global property's fields
 * It will require a tabName if current tab needs special attention
 * Custom component will be require to mock an Event Object
 * Be sure take test custom components carefully
 */

export const updateAutomobileData = (event, currentTab) => async (
    dispatch,
    getState
) => {
    try {
        event.persist();
        const {
            automobiles: { automobileData }
        } = getState();
        const { value, dataset, type, selectedIndex } = event.target;
        //  Throw error if value starts with `=`
        if (value && value.startsWith("=")) {
            throw new Error('"=" is not a valid entry!');
        }

        let name =
            event.target.name === "client_note"
                ? "client_notes"
                : event.target.name;

        switch (type) {
            case "select-one": {
                //	DESC: Get child name from dataset and get casecade from option's dataset
                const { child } = dataset;
                const { cascade } = event.target.options[selectedIndex].dataset;
                //	DESC: required settlement date to be set before they can set this to inactive.
                if (
                    name === "status_primary" &&
                    value === "I" &&
                    !automobileData.settlement_date
                ) {
                    return dispatch(
                        setAlert(
                            "In order to set the Asset Status to inactive there must be a settlement date in the system. Please provide a settlement date in the Disposition Tab.",
                            "info",
                            20000
                        )
                    );
                } else if (name === "status_primary" && value === "Y") {
                    if (
                        !confirm(
                            "Changing status to Active will remove current settlement date. Do you wish to continue?"
                        )
                    ) {
                        return false;
                    }
                }

                //	DESC: Check if child name is exist - child name name only avalable on some selects not all selects
                if (child) {
                    //	DESC: get child select tag using child name
                    const childSelect = document.querySelector(
                        `[name="${child}"]`
                    );

                    //	DESC: set child select value to empty when parent is changed
                    automobileData[childSelect.name] = "";

                    //	DESC loop through all options and hide all options don't include in casdade
                    Object.values(childSelect).forEach(option => {
                        if (
                            option.dataset &&
                            option.dataset.hasOwnProperty("code") &&
                            option.value !== ""
                        ) {
                            if (
                                cascade.split(",").includes(option.dataset.code)
                            ) {
                                option.disabled = false;
                                option.style.display = "block";
                            } else {
                                option.style.display = "none";
                                option.disabled = true;
                            }
                        }
                    });

                    //	DESC: Check if child of child exist and hide all options
                    if (childSelect.dataset.child) {
                        const childChildSelect = document.querySelector(
                            `[name='${childSelect.dataset.child}']`
                        );
                        automobileData[childSelect.dataset.child] = "";
                        childChildSelect &&
                            Object.values(childChildSelect).forEach(option => {
                                if (option.dataset && option.value !== "") {
                                    option.style.display = "none";
                                    option.disabled = true;
                                }
                            });
                    }
                }
                break;
            }
            default:
                break;
        }

        switch (currentTab) {
            case "status":
                dispatch(updateStatus(event));
                break;
            case "contacts":
                dispatch(updateContacts(event));
                break;
            default:
                //  DESC: This default will update fields according to field's name and field's value
                //  DESC: Please create custom case for special cases
                let updates = {};
                updates[name] = value;

                let gross_sales_amount =
                    name === "gross_sales_amount"
                        ? value
                        : automobileData.gross_sales_amount;
                let cost_of_commissions =
                    name === "cost_of_commissions"
                        ? value
                        : automobileData.cost_of_commissions;

                updates.total_sales_cost =
                    toNumberFloat(gross_sales_amount) -
                    toNumberFloat(cost_of_commissions);

                await dispatch({
                    type: SET_AUTOMOBILE_DATA,
                    payload: {
                        ...automobileData,
                        ...updates
                    }
                });
                break;
        }

        switch (name) {
            case "group_code":
            case "task_order":
                await dispatch(
                    triggerConfirmModal(
                        `Changing the ${dataset.displayName} field will remove all existing file shares. Are you sure you want to proceed?`,
                        name
                    )
                );
                break;
            default:
                break;
        }
        return true;
    } catch (error) {
        dispatch(handleError(error));
        return false;
    }
};

//	DESC: handle on field focus
export const onFieldFocus = event => async (dispatch, getState) => {
    const {
        MISC: {
            APP: {
                ROUTE: { verb }
            }
        }
    } = getState();
    if (verb === "add") {
        return;
    }

    try {
        const {
            automobiles: { automobileData }
        } = getState();
        const { name } = event.target;
        dispatch({
            type: SET_AUTOMOBILE_OLD_VALUE,
            payload: automobileData[name]
        });
    } catch (error) {
        dispatch(handleError(error));
        // eslint-disable-next-line consistent-return
        return 500;
    }
};

//	DESC: handle on field un-focus
export const onFieldUnFocus = event => async (dispatch, getState) => {
    const {
        MISC: {
            APP: {
                ROUTE: { verb }
            }
        }
    } = getState();
    if (verb === "add") {
        return;
    }
    try {
        const { name, dataset } = event.target;
        switch (name) {
            case "code":
            case "code_temp":
                await dispatch(
                    triggerConfirmModal(
                        `Changing the ${dataset.displayName} field will remove all existing file shares. Are you sure you want to proceed?`,
                        name
                    )
                );
                break;
            case "group_code":
            case "task_order":
                break;
            default:
                dispatch({ type: REMOVE_AUTOMOBILE_OLD_VALUE });
                break;
        }
    } catch (error) {
        dispatch(handleError(error));
        // eslint-disable-next-line consistent-return
        return 500;
    }
};

/**
 * @name    submitAutomobile
 * @returns {function(...[*]=)}
 */
export const submitAutomobile = () => async (dispatch, getState) => {
    try {
        dispatch({ type: SET_AUTOMOBILE_LOADING });

        const {
            automobiles: { automobileData }
        } = getState();

        const response = await axios.put(
            `/automobiles/edit/${automobileData.id}`,
            { data: automobileData }
        );

        dispatch(handleResponse(response));

        if (response.status === 200) {
            dispatch(setAlert("Submitted", "success"));
        }
    } catch (error) {
        dispatch(handleError(error));
    } finally {
        dispatch({ type: REMOVE_AUTOMOBILE_LOADING });
    }
};
